import { ResourceOptions } from 'react-admin';
import { FaTags } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingIntelCategories;
export const icon = FaTags;
export const options: ResourceOptions = {
  label: 'module.socialTrading.intelCategories',
};
